<template>
	<div class="info">
		<el-tabs v-model="activeName" type="card" class="responsive-tabs">
			<el-tab-pane label="基本信息" name="0">
				<el-form :inline="true" class="form" label-width="100px">
					<el-form-item label="用户ID">
						{{ formData.id }}
					</el-form-item>
					<el-form-item label="头像">
						<page-images v-model="formData.avatar" :limit="1" />
					</el-form-item>
					<el-form-item label="昵称">
						<el-input v-model="formData.nickname" class="input" placeholder="请填写姓名" />
					</el-form-item>
					<el-form-item label="手机号">
						{{ formData.phone }}
					</el-form-item>
					<el-form-item label="上级用户">
						<div v-if="formData.parent" class="parent-info">
							<el-avatar :size="isSmallScreen ? 24 : 30" :src="$img(formData.parent.avatar)" shape="square"></el-avatar>
							<span style="margin: 0 10px;">{{ formData.parent.nickname }}</span>
							<el-button type="text" size="small" @click="showChangeParent=true">更换</el-button>
							<el-button type="text" size="small" style="color: #F56C6C;" @click="unbindParent">解绑</el-button>
						</div>
						<div v-else>
							<span style="color: #909399; margin-right: 10px;">无上级用户</span>
							<el-button type="text" size="small" @click="showChangeParent=true">绑定上级</el-button>
						</div>
					</el-form-item>
					<el-form-item label="状态">
						<el-switch v-model="formData.status" :active-value="1" :inactive-value="0" active-color="#188fff"
							inactive-color="#e5e5e5"></el-switch>
					</el-form-item>
				</el-form>
			</el-tab-pane>

			<el-tab-pane label="保单记录" name="1">
				<!-- 优化后的保单统计 - 单行显示 -->
				<div class="policy-stats-compact">
					<div class="stat-item">
						<div class="stat-icon-compact">
							<i class="el-icon-s-data"></i>
						</div>
						<div class="stat-content-compact">
							<div class="stat-title-compact">总保额度</div>
							<div class="stat-number-compact">¥{{ formatAmount(formData.payTotal || 0) }}</div>
						</div>
					</div>
					<div class="stat-divider"></div>
					<div class="stat-item">
						<div class="stat-icon-compact">
							<i class="el-icon-document-checked"></i>
						</div>
						<div class="stat-content-compact">
							<div class="stat-title-compact">投保单数</div>
							<div class="stat-number-compact">{{ formData.payCount || 0 }}</div>
						</div>
					</div>
				</div>

				<basic-table :style="{ height: tableHeight }" api="app-order" :search="{user_id: formData.id}">
					<el-table-column prop="order_no" label="订单号" align="center" fixed="left" :width="isSmallScreen ? 100 : 120" />
					<el-table-column prop="policy_no" label="保单号" align="center" fixed="left" :width="isSmallScreen ? 100 : 120" />
					<el-table-column label="保险期间" align="center" show-overflow-tooltip :width="isSmallScreen ? 150 : 180">
						<template slot-scope="scope">
							<div>{{ scope.row.pln_start_date || '-' }}</div>
							<div>至</div>
							<div>{{ scope.row.pln_end_date || '-' }}</div>
							<div>({{ scope.row.insured_days || 0 }}天)</div>
						</template>
					</el-table-column>
					<el-table-column prop='insuredCount' label='被保人数' align='center' :width="isSmallScreen ? 80 : 100" />
					<el-table-column label="订单状态" align="center" show-overflow-tooltip :width="isSmallScreen ? 100 : 120">
						<template slot-scope="scope">
							<div>{{ scope.row.statusText || '-' }}</div>
							<div class="invoice" v-if="scope.row.invoice_status == 1">待开票</div>
							<div class="refund" v-if="scope.row.refund_status == 1">售后中</div>
						</template>
					</el-table-column>
					<el-table-column prop='payment_time' label='支付时间' align='center' :width="isSmallScreen ? 150 : 180" />
					<el-table-column prop='created_at' label='下单时间' align='center' :width="isSmallScreen ? 150 : 180" />
				</basic-table>
			</el-tab-pane>

			<el-tab-pane label="理赔记录" name="2">
				<basic-table :style="{ height: tableHeight }" api="app-order-claim" :search="{user_id: formData.id}">
					<el-table-column prop="policy_no" label="保单号" align="center" fixed="left" :width="isSmallScreen ? 100 : 120" />
					<el-table-column label="报案信息" align="center" show-overflow-tooltip :width="isSmallScreen ? 160 : 200">
						<template slot-scope="scope">
							<div>{{ scope.row.reporter }}</div>
							<div>{{ scope.row.reporter_telephone }}</div>
							<div class="regist-time">{{ scope.row.regist_time }}</div>
						</template>
					</el-table-column>
					<el-table-column prop='claim_amount' label='赔付金额' align='center' :width="isSmallScreen ? 100 : 120">
						<template slot-scope="scope">
							<span class="amount">¥{{ scope.row.claim_amount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="案件状态" align="center" :width="isSmallScreen ? 100 : 120">
						<template slot-scope="scope">
							<el-tag :type="getCaseStatusTagType(scope.row.case_status)" size="small">
								{{ getCaseStatusText(scope.row.case_status) }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="理赔状态" align="center" :width="isSmallScreen ? 80 : 100">
						<template slot-scope="scope">
							<el-tag :type="getStatusTagType(scope.row.status)" size="small">
								{{ scope.row.statusText }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="赔付状态" align="center" :width="isSmallScreen ? 80 : 100">
						<template slot-scope="scope">
							<el-tag :type="scope.row.settle_status ? 'success' : 'warning'" size="small">
								{{ scope.row.settle_status ? '已赔付' : '未赔付' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop='created_at' label='创建时间' align='center' :width="isSmallScreen ? 150 : 180" />
				</basic-table>
			</el-tab-pane>

			<el-tab-pane label="团队业绩" name="3">
				<!-- 时间筛选 -->
				<div class="filter-bar">
					<div class="filter-left">
						<span class="filter-label">时间范围：</span>
						<el-date-picker 
							v-model="dateRange"
							type="datetimerange" 
							range-separator="-"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']"
							class="compact-date-picker">
						</el-date-picker>
					</div>
					<div class="filter-actions">
						<el-button type="primary" size="small" @click="handleFilter" icon="el-icon-search">
							查询
						</el-button>
						<el-button size="small" @click="handleReset" icon="el-icon-refresh">
							重置
						</el-button>
					</div>
				</div>

				<!-- 业绩概览 -->
				<div class="stats-cards" v-if="teamData">
					<div class="stat-card">
						<div class="stat-icon user-icon">
							<i class="el-icon-user-solid"></i>
						</div>
						<div class="stat-content">
							<div class="stat-title">团队成员</div>
							<div class="stat-number">{{ teamData.user_count || 0 }}</div>
						</div>
					</div>

					<div class="stat-card">
						<div class="stat-icon order-icon">
							<i class="el-icon-document"></i>
						</div>
						<div class="stat-content">
							<div class="stat-title">总出单数</div>
							<div class="stat-number">{{ teamData.order_count || 0 }}</div>
						</div>
					</div>

					<div class="stat-card">
						<div class="stat-icon amount-icon">
							<i class="el-icon-money"></i>
						</div>
						<div class="stat-content">
							<div class="stat-title">总保费金额</div>
							<div class="stat-number">¥{{ formatAmount(teamData.total_amount || 0) }}</div>
						</div>
					</div>
				</div>

				<!-- 成员列表 -->
				<div class="member-section">
					<div class="section-header">
						<h3 class="section-title">团队成员</h3>
						<span class="section-count">共 {{ teamData.list ? teamData.list.length : 0 }} 位成员</span>
					</div>

					<div v-if="teamLoading" class="loading-state">
						<i class="el-icon-loading"></i>
						<span>加载中...</span>
					</div>

					<template v-else>
						<div v-if="teamData.list && teamData.list.length > 0" class="member-grid">
							<div v-for="(item, index) in teamData.list" :key="index" class="member-card">
								<div class="member-avatar">
									<el-avatar :size="isSmallScreen ? 40 : 48" :src="$img(item.avatar)" />
								</div>
								<div class="member-info">
									<div class="member-name">{{ item.nickname || '未设置昵称' }}</div>
									<div class="member-phone">{{ item.phone || '未设置手机号' }}</div>
								</div>
								<div class="member-stats">
									<div class="stat">
										<div class="stat-label">出单数</div>
										<div class="stat-value">{{ item.order_count || 0 }}</div>
									</div>
									<div class="stat">
										<div class="stat-label">保费金额</div>
										<div class="stat-value amount">¥{{ formatAmount(item.total_amount || 0) }}</div>
									</div>
								</div>
							</div>
						</div>
						
						<div v-else class="empty-state">
							<i class="el-icon-user"></i>
							<div class="empty-text">暂无团队成员</div>
							<div class="empty-desc">该用户还没有团队成员</div>
						</div>
					</template>
				</div>
			</el-tab-pane>
		</el-tabs>

		<div class="bottom" v-if="activeName == '0'">
			<el-button @click="cancel" size="medium">取消</el-button>
			<el-button @click="save(formData)" size="medium" type="primary">{{formData.id ? '保存' : '提交'}}</el-button>
		</div>

		<!-- 更换上级用户弹窗 -->
		<el-dialog
			title="选择上级用户"
			:visible.sync="showChangeParent"
			:width="dialogWidth"
			:modal="false"
			:before-close="handleParentDialogClose">
			
			<div class="user-select-dialog">
				<div class="search-bar">
					<el-input
						v-model="parentSearch.keyword"
						placeholder="请输入用户昵称或手机号搜索"
						:style="{ width: isSmallScreen ? '100%' : '300px' }"
						clearable
						@clear="searchParentUsers"
						@keyup.enter.native="searchParentUsers">
						<el-button slot="append" icon="el-icon-search" @click="searchParentUsers"></el-button>
					</el-input>
				</div>
				
				<el-table
					:data="parentUserList"
					:style="{ width: '100%', marginTop: '15px' }"
					:height="isSmallScreen ? 300 : 400"
					highlight-current-row
					@current-change="handleParentUserSelect">
					<el-table-column prop="id" label="ID" :width="isSmallScreen ? 60 : 80" align="center" />
					<el-table-column label="头像" :width="isSmallScreen ? 60 : 80" align="center">
						<template slot-scope="scope">
							<el-avatar :size="isSmallScreen ? 32 : 40" shape="square" :src="$img(scope.row.avatar)"></el-avatar>
						</template>
					</el-table-column>
					<el-table-column prop="nickname" label="昵称" :min-width="isSmallScreen ? 100 : 120" />
					<el-table-column prop="phone" label="手机号" :width="isSmallScreen ? 110 : 130" />
					<el-table-column prop="status" label="状态" :width="isSmallScreen ? 60 : 80" align="center">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status" size="small">正常</el-tag>
							<el-tag v-else type="danger" size="small">封禁</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" :width="isSmallScreen ? 60 : 80" align="center">
						<template slot-scope="scope">
							<el-button
								type="primary"
								size="mini"
								:disabled="scope.row.id === formData.id"
								@click="selectParentUser(scope.row)">
								选择
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				
				<div class="pagination">
					<el-pagination
						@size-change="handleParentSizeChange"
						@current-change="handleParentPageChange"
						:current-page="parentSearch._page"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="parentSearch._size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="parentUserTotal">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Object,
				default: () => ({
					status: 1,
				}),
			},
		},
		data() {
			return {
				activeName: '0',
				showChangeParent: false,
				parentUserList: [],
				parentUserTotal: 0,
				parentSearch: {
					keyword: '',
					_page: 1,
					_size: 20,
				},
				selectedParentUser: null,
				// 创建表单数据的副本
				formData: {},
				// 团队数据
				teamData: {
					list: [],
					user_count: 0,
					order_count: 0,
					total_amount: 0,
				},
				teamLoading: false,
				// 时间筛选相关
				dateRange: [],
				teamForm: {
					startTime: '',
					endTime: '',
				},
				table: {
					data: [],
					form: {},
					search: {
						_page: 1,
						_size: 20,
					},
					_count: 0,
				},
				// 响应式相关
				screenWidth: document.documentElement.clientWidth,
			}
		},
		computed: {
			// 判断是否为小屏幕
			isSmallScreen() {
				return this.screenWidth <= 1366;
			},
			// 表格高度
			tableHeight() {
				return this.isSmallScreen ? '400px' : '600px';
			},
			// 对话框宽度
			dialogWidth() {
				return this.isSmallScreen ? '90%' : '800px';
			}
		},
		watch: {
			// 监听 prop 变化，更新本地数据
			data: {
				handler(newVal) {
					this.deepCopyData(newVal);
				},
				deep: true,
				immediate: true
			},
			'showChangeParent'(newVal) {
				if (newVal) {
					// 打开弹窗时搜索用户
					this.searchParentUsers();
				}
			},
			// 监听标签页切换，当下级队员标签页激活时加载团队数据
			activeName(newVal) {
				if (newVal === '3') {
					this.loadTeamData();
				}
			}
		},
		mounted() {
			// 初始化时深拷贝数据
			this.deepCopyData(this.data);
			window.addEventListener('resize', this.handleResize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			// 深拷贝数据
			deepCopyData(sourceData) {
				// 简单的深拷贝方法，对于复杂对象可能需要使用 lodash 的 cloneDeep
				this.formData = JSON.parse(JSON.stringify(sourceData || {}));
			},
			
			// 响应窗口大小变化
			handleResize() {
				this.screenWidth = document.documentElement.clientWidth;
			},
			
			// 加载团队数据
			loadTeamData() {
				if (!this.formData.id) return;
				
				this.teamLoading = true;
				
				// 构建请求参数
				const params = {
					id: this.formData.id
				};
				
				// 添加时间筛选参数
				if (this.teamForm.startTime) {
					params.startTime = this.teamForm.startTime;
				}
				if (this.teamForm.endTime) {
					params.endTime = this.teamForm.endTime;
				}
				
				this.$get('teamList', params, true).then(res => {
					this.teamData = res.data || {};
					this.teamLoading = false;
				}).catch(err => {
					this.$warning(err);
					this.teamLoading = false;
				});
			},
			
			// 格式化金额
			formatAmount(amount) {
				return parseFloat(amount).toFixed(2);
			},
			
			// 处理筛选
			handleFilter() {
				if (this.dateRange && this.dateRange.length === 2) {
					this.teamForm.startTime = this.dateRange[0];
					this.teamForm.endTime = this.dateRange[1];
				} else {
					this.teamForm.startTime = '';
					this.teamForm.endTime = '';
				}
				this.loadTeamData();
			},
			
			// 重置筛选
			handleReset() {
				this.dateRange = [];
				this.teamForm.startTime = '';
				this.teamForm.endTime = '';
				this.loadTeamData();
			},
			
			// 搜索上级用户
			searchParentUsers() {
				const searchParams = {
					_page: this.parentSearch._page,
					_size: this.parentSearch._size,
				};
				
				// 添加搜索关键词
				if (this.parentSearch.keyword) {
					searchParams.nickname = this.parentSearch.keyword;
				}
				
				this.$get('app-user', searchParams).then(res => {
					this.parentUserList = res.data;
					this.parentUserTotal = res.extra.pageInfo.count;
				}).catch(err => {
					this.$warning(err);
				});
			},
			
			// 选择上级用户
			selectParentUser(user) {
				if (user.id === this.formData.id) {
					this.$warning('不能选择自己作为上级用户');
					return;
				}
				
				this.selectedParentUser = user;
				this.confirmChangeParent();
			},
			
			// 确认更换上级用户
			confirmChangeParent() {
				if (!this.selectedParentUser) {
					this.$warning('请先选择一个用户');
					return;
				}
				
				// 更新本地表单数据，不影响父组件
				this.formData.pid = this.selectedParentUser.id;
				this.formData.parent = {
					id: this.selectedParentUser.id,
					avatar: this.selectedParentUser.avatar,
					nickname: this.selectedParentUser.nickname
				};
				
				// this.$message.success('上级用户更换成功');
				this.showChangeParent = false;
				this.selectedParentUser = null;
			},
			
			// 解绑上级用户
			unbindParent() {
				this.$confirm('确定要解绑当前上级用户吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.formData.pid = 0;
					this.formData.parent = null;
					// this.$message.success('解绑成功');
				}).catch(() => {});
			},
			
			// 处理弹窗关闭
			handleParentDialogClose(done) {
				this.selectedParentUser = null;
				this.parentSearch.keyword = '';
				this.parentSearch._page = 1;
				done();
			},
			
			// 分页大小改变
			handleParentSizeChange(size) {
				this.parentSearch._size = size;
				this.searchParentUsers();
			},
			
			// 页码改变
			handleParentPageChange(page) {
				this.parentSearch._page = page;
				this.searchParentUsers();
			},
			
			// 表格行选择
			handleParentUserSelect(currentRow) {
				this.selectedParentUser = currentRow;
			},
			
			save(data) {
				this.$load();
				// 保存时提交本地表单数据
				this.$save('app-user', data).then(res => {
					// 保存成功后，可以选择更新父组件数据
					this.$emit('save', data);
				}).catch(err => {
					this.$warning(err), this.$load(false);
				});
			},
			
			cancel() {
				// 取消时重置表单数据
				this.deepCopyData(this.data);
				this.$emit('cancel');
			},
			
			// 获取证件类型文本
			getCertTypeText(type) {
				const typeMap = {
					'01': '身份证',
					'02': '护照',
					'03': '港澳居民往来内地通行证',
					'04': '台湾居民往来大陆通行证'
				};
				return typeMap[type] || '未知';
			},

			// 获取案件状态文本
			getCaseStatusText(status) {
				const statusMap = {
					'00': '未提交',
					'01': '立案录入',
					'02': '立案审核',
					'03': '定损',
					'04': '核损',
					'05': '核损初审',
					'06': '核损复审',
					'07': '单证确认',
					'08': '结案理算',
					'09': '结案核赔',
					'11': '已决已结',
					'12': '零赔付',
					'13': '拒赔',
					'14': '立案注销',
					'15': '报案注销',
					'25': '已决未结',
					'26': '已决已结',
					'27': '结案核赔',
					'28': '结案理算',
					'19': '结案理算',
					'20': '结案核赔',
					'10': '已决未结',
					'16': '零结案',
					'17': '拒赔',
					'18': '立案注销',
					'29': '核价'
				};
				return statusMap[status] || '未知';
			},

			// 获取案件状态标签类型
			getCaseStatusTagType(status) {
				if (['11', '12', '13', '14', '15', '26'].includes(status)) return 'success';
				if (['01', '02', '03', '04', '05', '06', '07'].includes(status)) return 'warning';
				if (['08', '09', '10', '16', '17', '18', '19', '20', '25', '27', '28', '29'].includes(status))
					return 'info';
				return 'info';
			},

			// 获取状态标签类型
			getStatusTagType(status) {
				const typeMap = {
					0: 'warning', // 进行中
					1: 'success', // 已完成
					2: 'danger' // 未通过
				};
				return typeMap[status] || 'info';
			},
		}
	}
</script>

<style lang="scss" scoped>
	.info {
		width: 100%;
		
		/* 小屏幕适配 */
		@media (max-width: 1366px) {
			.form {
				width: 95% !important;
				height: auto !important;
				max-height: 60vh;
				overflow-y: auto;
				padding-top: 10px;
				
				.input {
					width: 250px !important;
				}
			}
			
			.bottom {
				width: 90% !important;
				bottom: 20px;
				padding: 8px;
			}

			/* 统计卡片在小屏幕上单列显示 */
			.stats-cards {
				grid-template-columns: 1fr !important;
				gap: 12px;
				padding: 16px;
				
				.stat-card {
					padding: 16px;
					
					.stat-icon {
						width: 40px;
						height: 40px;
						font-size: 18px;
						margin-right: 12px;
					}
					
					.stat-number {
						font-size: 18px;
					}
				}
			}
			
			/* 筛选栏在小屏幕上垂直布局 */
			.filter-bar {
				flex-direction: column;
				align-items: flex-start;
				gap: 12px;
				padding: 16px;
				
				.filter-left {
					width: 100%;
					
					.compact-date-picker {
						width: 100% !important;
					}
				}
				
				.filter-actions {
					width: 100%;
					justify-content: flex-end;
				}
			}
			
			/* 成员卡片在小屏幕上调整布局 */
			.member-grid {
				grid-template-columns: 1fr !important;
			}
			
			.member-card {
				flex-direction: column;
				text-align: center;
				gap: 12px;
				padding: 12px;
				
				.member-info {
					margin-right: 0;
				}
				
				.member-stats {
					width: 100%;
					justify-content: space-around;
				}
			}

			/* 父级信息在小屏幕上的适配 */
			.parent-info {
				flex-wrap: wrap;
				gap: 6px;
				
				.el-avatar {
					margin-right: 6px;
				}
				
				.el-button {
					margin: 2px 0;
				}
			}
		}

		/* 紧凑型保单统计样式 - 单行显示 */
		.policy-stats-compact {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 0;
			padding: 16px 20px;
			background: white;
			border-bottom: 1px solid #e8e8e8;

			.stat-item {
				display: flex;
				align-items: center;
				padding: 0 20px;
				flex: 1;
				justify-content: center;

				.stat-icon-compact {
					width: 36px;
					height: 36px;
					border-radius: 6px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 16px;
					margin-right: 12px;
					background: rgba(64, 158, 255, 0.1);
					color: #409eff;
				}

				.stat-content-compact {
					.stat-title-compact {
						color: #909399;
						font-size: 13px;
						margin-bottom: 2px;
						white-space: nowrap;
					}

					.stat-number-compact {
						color: #303133;
						font-size: 18px;
						font-weight: 600;
						white-space: nowrap;
					}
				}
			}

			.stat-divider {
				width: 1px;
				height: 40px;
				background: #e8e8e8;
				margin: 0 10px;
			}

			/* 小屏幕适配 */
			@media (max-width: 1366px) {
				padding: 12px 16px;
				
				.stat-item {
					padding: 0 15px;
					
					.stat-icon-compact {
						width: 32px;
						height: 32px;
						font-size: 14px;
						margin-right: 10px;
					}
					
					.stat-content-compact {
						.stat-title-compact {
							font-size: 12px;
						}
						
						.stat-number-compact {
							font-size: 16px;
						}
					}
				}
				
				.stat-divider {
					height: 32px;
					margin: 0 8px;
				}
			}

			/* 超小屏幕适配 */
			@media (max-width: 768px) {
				flex-direction: column;
				gap: 12px;
				
				.stat-divider {
					display: none;
				}
				
				.stat-item {
					width: 100%;
					justify-content: flex-start;
					padding: 0;
				}
			}
		}

		/* 通用样式 */
		.form {
			margin: 0 auto;
			width: 90%;
			height: 70vh;
			padding-top: 20px;

			.input {
				width: 300px;
			}
		}

		.bottom {
			width: 50%;
			position: fixed;
			bottom: 30px;
			display: flex;
			justify-content: center;
			background: white;
			padding: 10px;
			border-top: 1px solid #e8e8e8;
			z-index: 1000;
		}

		.el-form-item {
			width: 100%;
			margin-bottom: 16px;
		}

		.parent-info {
			display: flex;
			align-items: center;
		}

		.user-select-dialog {
			.search-bar {
				display: flex;
				align-items: center;
				margin-bottom: 15px;
				
				@media (max-width: 1366px) {
					flex-direction: column;
					gap: 10px;
				}
			}
			
			.pagination {
				display: flex;
				justify-content: center;
				margin-top: 15px;
			}
		}

		/* 团队业绩样式 */
		.filter-bar {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 20px 24px;
			background: white;
			border-bottom: 1px solid #e8e8e8;
			margin-bottom: 0;

			.filter-left {
				display: flex;
				align-items: center;
				gap: 12px;

				.filter-label {
					color: #606266;
					font-size: 14px;
					white-space: nowrap;
				}
			}

			.compact-date-picker {
				width: 320px;
			}

			.filter-actions {
				display: flex;
				gap: 8px;
			}
		}

		.stats-cards {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
			gap: 16px;
			padding: 24px;
			background: white;

			.stat-card {
				display: flex;
				align-items: center;
				padding: 20px;
				background: #f8f9fa;
				border-radius: 8px;
				border: 1px solid #e8e8e8;
				transition: all 0.2s ease;

				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
				}

				.stat-icon {
					width: 48px;
					height: 48px;
					border-radius: 8px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 20px;
					margin-right: 16px;

					&.user-icon {
						background: rgba(64, 158, 255, 0.1);
						color: #409eff;
					}

					&.order-icon {
						background: rgba(103, 194, 58, 0.1);
						color: #67c23a;
					}

					&.amount-icon {
						background: rgba(255, 158, 66, 0.1);
						color: #ff9e42;
					}
				}

				.stat-content {
					.stat-title {
						color: #909399;
						font-size: 14px;
						margin-bottom: 4px;
					}

					.stat-number {
						color: #303133;
						font-size: 24px;
						font-weight: 600;
					}
				}
			}
		}

		.member-section {
			padding: 0 24px 24px;
			background: white;

			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 20px;
				padding-top: 24px;

				.section-title {
					color: #303133;
					font-size: 16px;
					font-weight: 600;
					margin: 0;
				}

				.section-count {
					color: #909399;
					font-size: 14px;
				}
			}

			.member-grid {
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
				gap: 16px;
			}

			.member-card {
				display: flex;
				align-items: center;
				padding: 16px;
				background: #f8f9fa;
				border-radius: 8px;
				border: 1px solid #e8e8e8;
				transition: all 0.2s ease;

				&:hover {
					background: white;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
				}

				.member-avatar {
					margin-right: 12px;
				}

				.member-info {
					flex: 1;

					.member-name {
						color: #303133;
						font-weight: 500;
						margin-bottom: 4px;
					}

					.member-phone {
						color: #909399;
						font-size: 12px;
					}
				}

				.member-stats {
					display: flex;
					gap: 16px;

					.stat {
						text-align: center;

						.stat-label {
							color: #909399;
							font-size: 12px;
							margin-bottom: 4px;
						}

						.stat-value {
							color: #303133;
							font-weight: 600;
							font-size: 14px;

							&.amount {
								color: #67c23a;
							}
						}
					}
				}
			}

			.loading-state {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 60px;
				color: #909399;
				gap: 8px;
			}

			.empty-state {
				text-align: center;
				padding: 60px 20px;
				color: #c0c4cc;

				i {
					font-size: 48px;
					margin-bottom: 16px;
				}

				.empty-text {
					font-size: 14px;
					color: #909399;
					margin-bottom: 8px;
				}

				.empty-desc {
					font-size: 12px;
					color: #c0c4cc;
				}
			}
		}

		/* 标签页在小屏幕上的优化 */
		::v-deep .responsive-tabs {
			.el-tabs__header {
				.el-tabs__nav-wrap {
					overflow-x: auto;
					
					&::-webkit-scrollbar {
						height: 4px;
					}
				}
				
				.el-tabs__item {
					padding: 0 16px;
					font-size: 14px;
					
					@media (max-width: 1366px) {
						padding: 0 12px;
						font-size: 13px;
					}
				}
			}
			
			.el-tabs__content {
				padding-bottom: 80px; /* 为底部按钮留出空间 */
			}
		}
	}
</style>